function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useMemo } from 'react';
import { classnames } from '@bydesign-ui/utils';
import { useRefCallback } from '@bydesign-ui/hooks';
import { usePrefixCls } from '@byte-design/config';
export function Badge(props) {
  var _props$placement = props.placement,
      placement = _props$placement === void 0 ? 'top-right' : _props$placement,
      className = props.className,
      children = props.children,
      content = props.content,
      offset = props.offset,
      onBadgeClick = props.onBadgeClick,
      _props$badgeStyle = props.badgeStyle,
      badgeStyle = _props$badgeStyle === void 0 ? {} : _props$badgeStyle,
      _props$show = props.show,
      show = _props$show === void 0 ? true : _props$show,
      _props$inline = props.inline,
      inline = _props$inline === void 0 ? false : _props$inline,
      extra = _objectWithoutProperties(props, ["placement", "className", "children", "content", "offset", "onBadgeClick", "badgeStyle", "show", "inline"]);

  var cls = classnames(usePrefixCls('badge', {
    inline: inline
  }), className);
  var supCls = usePrefixCls('badge-sup', {
    placement: placement,
    show: show,
    'has-children': !!children
  });
  var onBadgeClickCallback = useRefCallback(onBadgeClick);
  var styles = useMemo(function () {
    return offset ? _objectSpread(_objectSpread({}, badgeStyle), {}, {
      transform: "translate(".concat(offset.x, "px, ").concat(offset.y, "px)")
    }) : badgeStyle;
  }, [offset, badgeStyle]);
  return React.createElement("div", Object.assign({
    className: cls
  }, extra), inline && React.createElement("span", {
    key: "badge-sup",
    className: supCls,
    style: styles,
    onClick: onBadgeClickCallback
  }, content), children, !inline && React.createElement("sup", {
    key: "badge-sup",
    className: supCls,
    style: styles,
    onClick: onBadgeClickCallback
  }, content));
}
export default Badge;